import classes from "./userprofile.module.css";

function Usertopbackground() {
  return (
    <>
      <div style={{ position: "relative" }}>
        <div
          className={`${classes.profile_bg_container} ${classes.fadeInPlace}`}
        >
          <div className={classes.small_circle}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Usertopbackground;
